import { THEME } from '@lyon/utils/theme';
import { BlockOverrides } from 'baseui/block';

export const SCORE: BlockOverrides = {
  Block: {
    style: {
      fontSize: '20px',
      borderBottomColor: THEME.colors.white,
      borderTopColor: THEME.colors.white,
      borderRightColor: THEME.colors.white,
      borderLeftColor: THEME.colors.white,
      borderBottomStyle: 'solid',
      borderTopStyle: 'solid',
      borderRightStyle: 'solid',
      borderLeftStyle: 'solid',
      borderBottomWidth: '1px',
      borderTopWidth: '1px',
      borderRightWidth: '1px',
      borderLeftWidth: '1px',
      paddingLeft: '24px',
      paddingRight: '24px',
      marginTop: 0,
      marginBottom: '24px',
      width: 'fit-content',

      [THEME.media.large]: {
        fontSize: '24px',
        marginTop: 0,
        marginBottom: 0,
      },
    },
  },
};

export const BLOCK: BlockOverrides = {
  Block: {
    style: {
      display: 'grid',
      width: '100%',
      marginTop: '32px',
      marginBottom: '32px',

      [THEME.media.large]: {
        width: '70%',
      },
    },
  },
};

export const HEADING: BlockOverrides = {
  Block: {
    style: {
      marginTop: 0,
      marginBottom: 0,
      fontSize: '20px',
    },
  },
};

export const INNER: BlockOverrides = {
  Block: {
    style: {
      display: 'flex',
      flexDirection: 'column-reverse',
      marginBottom: '12px',

      [THEME.media.large]: {
        display: 'grid',
        justifyContent: 'space-between',
        gridTemplateColumns: 'auto auto',
        gridColumnGap: '64px',
        marginBottom: '16px',
      },
    },
  },
};
